import { ConfirmationAirTable } from "./ConfirmationAirTable";
import type { ConfirmationCategoryTableProps } from "./tableTypes";

/** 船票按自身路线分组，列与飞机保持一致。 */
export function ConfirmationShipTable(props: ConfirmationCategoryTableProps) {
  return <ConfirmationAirTable {...props} mode="ship" />;
}
